import { graphql } from '../../../graphql/generated';

export const LAB_AI_SETTINGS_QUERY = graphql(`
  query LabAdminAiSettings($id: ID!) {
    lab(id: $id) {
      id
      aiSystemPromptExtension
    }
  }
`);

export const UPDATE_LAB_AI_SETTINGS_MUTATION = graphql(`
  mutation UpdateLabAiSettings($id: ID!, $input: LabAiSettingsInput!) {
    updateLabAiSettings(id: $id, input: $input) {
      id
    }
  }
`);
